/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import * as React from 'react';
import {DefaultEntityAttribute} from './DefaultEntityAttribute';
import {
    EntityAttribute,
    EntityAttributeProps,
    ENTITY_ATTRIBUTE_DEFAULT_PROPS,
} from './EntityAttribute';

/**
 * The default props for a boolean entity attribute
 */
export const BOOLEAN_ENTITY_ATTRIBUTE_DEFAULT_PROPS = {
    ...ENTITY_ATTRIBUTE_DEFAULT_PROPS,
    renderInput: (component: EntityAttribute) => {
        if (typeof component.state.value !== 'boolean') {
            return <></>;
        }
        return (
            <input
                disabled={component.props.disabled}
                type="checkbox"
                checked={component.state.value}
                onChange={(event) => {
                    component.props.onFieldEditedValue(
                        component,
                        event.currentTarget.checked
                    );
                }}
            />
        );
    },
};

/**
 * Component for a boolean entity attribute
 */
export class BooleanEntityAttribute extends React.Component<EntityAttributeProps> {
    public static defaultProps = BOOLEAN_ENTITY_ATTRIBUTE_DEFAULT_PROPS;

    render() {
        return <DefaultEntityAttribute {...this.props} />;
    }
}
